export const LOADING_PERIOD = { weeks: 1 };
export const LOADING_LIMIT = 25;
